angular.module('core')
  .service('edxCustomerSettingsService', [
    '$rootScope',
    '$state',
    'profileApi',
    'authentication',
    'dblCookieService',
    function(
      $rootScope,
      $state,
      profileApi,
      authentication,
      dblCookieService) {

    var HIDE_FTUE_DEPRECATED = 'HIDE_FTUE';
    var HIDE_FTUE = 'HIDE_FTUE18';
    var FTUE_RESOURCES_VISITED = 'FTUE_RV';

    var self = this;

    // if value is truthy replace with 1, otherwise remove property
    var reduceBooleanValuedObject = function (object) {
      var reduced = {};
      _.each(object, function (value, key) {
        if (value) {
          reduced[key] = 1;
        }
      });

      return reduced;
    };

    var expandBooleanValuedObject = function (object) {
      return _.mapValues(object, function (value) {
        return !!value;
      });
    };

    self.getHideFtue = function () {

      var hideFtue = false;
      // Returns boolean if cookie is set, undefined otherwise
      if (dblCookieService.getPermanent(HIDE_FTUE) === 'true') {
        // since cookie logic was released first, we still check it, but then store in DB the preference for persistence
        self.setHideFtue(true);
        hideFtue = true;
      }
      // then we check the preferences returned on the customerInfo Object as well
      var customer = authentication.getCustomer();
      var settingStoreHideFtue = false;
      if (customer.preferences && customer.preferences.hide_ftue) {
        settingStoreHideFtue = customer.preferences.hide_ftue;
      }
      // coerce value to boolean and check it.
      if (settingStoreHideFtue === "true") {
        hideFtue = true;
      }

      return hideFtue;
    };

    self.setAutoShowFtue = function (value) {
        $rootScope.AUTO_SHOW_FTUE = value;
    };
    self.getAutoShowFtue = function () {
        return $rootScope.AUTO_SHOW_FTUE;
    };

    self.getFtueResourcesVisited = function () {
      var encodedState = dblCookieService.getPermanent(FTUE_RESOURCES_VISITED);
      var resourcesVisited = {};
      if (encodedState) {
        try {
          var parsedObject = JSON.parse(encodedState);
          // resourcesVisited should always be an object, but check anyway just
          // to make sure we always return an object
          if (_.isObject(parsedObject)) {
            resourcesVisited = expandBooleanValuedObject(parsedObject);
          } else {
            resourcesVisited = {};
          }
        } catch(e) {
          // never expect to get here
        }
      }

      return resourcesVisited;
    };

    self.setHideFtue = function (hide) {
      // we do not want to store FTUE preferences for impersonated sessions (but we will read the stored settings if they exist)
      var customer = authentication.getCustomer();
      var impersonated_id = customer.impersonated_admin_id;
      var district_id = customer.district_id;
      if (impersonated_id === null) {
        profileApi.setCustomerPreference(district_id, profileApi.HIDE_FTUE, "true");
        dblCookieService.removePermanent(HIDE_FTUE_DEPRECATED);
        customer.preferences.hide_ftue = hide ? "true" : "false";
      }
    };

    self.setFtueResourcesVisited = function (resourcesVisited) {
      var encodedState = JSON.stringify(reduceBooleanValuedObject(resourcesVisited));
      dblCookieService.setPermanent(FTUE_RESOURCES_VISITED, encodedState);
    };
  }]);
